import { createFileRoute } from '@tanstack/react-router'
import { GlossaryIndexPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/glossary/')({
  loader: () => loadPageData({ data: { kind: 'glossary', locale: 'en' } }),
  head: () => staticRouteHead('glossary', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <GlossaryIndexPage />
    </CatalogProvider>
  )
}
